export default "/_next/static/images/header-bg-188301489d012ec6dc4d80a6e55622e3.png";